import type { SortingState } from '../../types/table';

// Validates a table sort read back from localStorage. Returns undefined when nothing
// usable was saved, so the caller keeps its default sort. An empty array is valid
// (no sort / backend order).
export const parseSortingState = (value: unknown): SortingState | undefined => {
  if (!Array.isArray(value)) return undefined;
  const isValid = value.every(
    (sort) =>
      sort != null &&
      typeof sort === 'object' &&
      typeof sort.id === 'string' &&
      sort.id !== '' &&
      typeof sort.desc === 'boolean',
  );
  return isValid ? value.map(({ id, desc }) => ({ id, desc })) : undefined;
};
